import { useState } from "react";

const FEATURE_FLAGS_KEY = "feature_flags";

export const getFeatureFlag = (flagName, defaultValue = false) => {
  if (typeof window === "undefined") return defaultValue;
  try {
    const flags = JSON.parse(localStorage.getItem(FEATURE_FLAGS_KEY) || "{}");
    return flags[flagName] ?? defaultValue;
  } catch (error) {
    console.error("Error reading feature flag:", error);
    return defaultValue;
  }
};

const useFeatureFlag = (flagName, defaultValue = false) => {
  const [isEnabled, setIsEnabled] = useState(() => {
    return getFeatureFlag(flagName, defaultValue);
  });

  const setFeatureFlag = (value) => {
    try {
      const flags = JSON.parse(localStorage.getItem(FEATURE_FLAGS_KEY) || "{}");
      const newFlags = { ...flags, [flagName]: value };
      localStorage.setItem(FEATURE_FLAGS_KEY, JSON.stringify(newFlags));
      setIsEnabled(value);
    } catch (error) {
      console.error("Error setting feature flag:", error);
    }
  };

  return [isEnabled, setFeatureFlag];
};

export default useFeatureFlag;
